import "./StepCard.scss";
import { Col } from "antd";
import React from "react";
import { BackIcon } from "../../../assets/svg";
import { AppButton } from "../../atoms/Button";
import type { StepCardAction, StepCardProps } from "./types";

type ActionLabelProps = {
  label: string;
  icon?: React.ReactElement;
  iconPosition?: "start" | "end";
};

const ActionLabel = (props: ActionLabelProps) => {
  const { label, icon, iconPosition = "start" } = props;

  return (
    <span className="step-card__action-inner">
      {iconPosition === "start" ? icon : null}
      <span>{label}</span>
      {iconPosition === "end" ? icon : null}
    </span>
  );
};

const renderAction = (action: StepCardAction) => (
  <AppButton key={action.key} variant={action.variant ?? "primary"} disabled={action.disabled} onClick={action.onClick}>
    <ActionLabel label={action.label} icon={action.icon} iconPosition={action.iconPosition} />
  </AppButton>
);

export const StepCard = (props: StepCardProps) => {
  const { title, children, onBack, backLabel = "Back", actions = [], className } = props;
  const showFooter = Boolean(onBack) || actions.length > 0;
  const rootClassName = ["step-card", className].filter(Boolean).join(" ");

  return (
    <Col span={24} className={rootClassName}>
      {title ? (
        <>
          <Col span={24} className="step-card__header">
            <p className="step-card__title">{title}</p>
          </Col>
          <Col span={24} className="step-card__divider" />
        </>
      ) : null}

      {children}

      {showFooter ? (
        <div className="step-card__footer">
          <div className="step-card__footer-left">
            {onBack ? (
              <AppButton variant="secondary" onClick={onBack}>
                <ActionLabel label={backLabel} icon={<BackIcon width="16px" height="16px" />} />
              </AppButton>
            ) : null}
          </div>
          <div className="step-card__footer-right">{actions.map(renderAction)}</div>
        </div>
      ) : null}
    </Col>
  );
};

export default StepCard;
